module.exports = __webpack_public_path__ + "assets/map-e448df.svg";